import { propertyUtils } from '@zg-rentals/rental-manager-env';

import { useSelector } from '../../../../selectors/useSelector';

import DateAvailableFormField from './DateAvailableFormField';
import { WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

const FormSectionContainer = () => {
  const currentProperty = useSelector((state) => state.properties.currentProperty);
  const isRoomForRent = propertyUtils.isRoomForRent({ currentProperty });

  const heading = isRoomForRent ? 'When is the room available to rent?' : 'When is your property available to rent?';

  return (
    <WizardFormSectionContainer data-testid="FormSectionContainer">
      <WizardHeading level={1} textStyle="heading-sm">
        {heading}
      </WizardHeading>

      <DateAvailableFormField />
    </WizardFormSectionContainer>
  );
};

export default FormSectionContainer;
